import { Flex, Typography } from 'antd';
import type { ReactNode } from 'react';

const { Title, Text } = Typography;

type Props = {
  title: string;
  subtitle: string;
  icon?: ReactNode;
  actions?: ReactNode;
};

export function KmsPageHeader({ title, subtitle, icon, actions }: Props) {
  return (
    <Flex
      className="kms-page-header"
      justify="space-between"
      align="flex-start"
      gap={16}
      wrap="wrap"
    >
      <Flex align="flex-start" gap={14} className="app-page-header-left">
        {icon ? <div className="kms-page-header__icon">{icon}</div> : null}
        <div>
          <Title level={2} className="ds-page-title" style={{ margin: 0 }}>
            {title}
          </Title>
          <Text type="secondary" className="om-dashboard-header__subtitle">
            {subtitle}
          </Text>
        </div>
      </Flex>
      {actions}
    </Flex>
  );
}
